export function loadYouTubeIframeAPI() {
    return new Promise((resolve, reject) => {
        // Check if the API is already loaded
        if (window.YT && window.YT.Player) {
            resolve(window.YT);
            return;
        }

        // Define a callback function to be called when the API is ready
        window.onYouTubeIframeAPIReady = () => {
            resolve(window.YT);
        };
    });
}